﻿import { Utility } from './Utility.js';
export { Upload };

/**
 * Class Upload
 */
const Upload = function (userId) {
    // Define this
    var myUpload = this;

    // -- begin public variable -------------------------------------------------------------------

    // Dropzone definition
    this.dropzoneUpload = null;

    // Fake id entity (for entity creation)
    this.fakeIdEntity = "fake-id-" + Math.random().toString().split(".")[1];

    // New id entity for creation
    this.newIdEntity = null;

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // User id
    this._userId = userId;

    // Utility
    this._utility = new Utility();

    // Template button
    this._buttonsTemplate =
        '<div class="file-info-button">' +
          '<table cellspacing="0" cellpadding="0" border="0" class="ui-pg-table navtable">' +
            '<tbody>' +
              '<tr>' +
                '<td class="ui-pg-button ui-corner-all" title="Remo&#231;&#227;o" style="padding-right: 5px;">' +
                  '<div class="dz-remove delete-file" data-dz-remove style="padding-right: 2px">' +
                    '<span class="fa fa-times-circle file-info-button-class"></span>' +
                  '</div>' +
                '</td>' +
                '<td class="ui-pg-button ui-corner-all" title="Download" style="padding-right: 5px;">' +
                  '<div class="dz-remove download-file" style="padding-right: 2px" id-entity="ID_ENTITY" href="S_File" id-file-info="IDFILE" name-entity="NAME_ENTITY" extension="EXTENSION_FILE" name-file-user="NAME_FILE">' +
                    '<span class="fa fa-download file-info-button-class"></span>' +
                  '</div>' +
                '</td>' +
                '<td class="ui-pg-button ui-corner-all" title="Gravar observação" style="display:none;">' +
                  '<div class="dz-remove save-file-attribute" style="padding-right: 2px" idfile="IDFILE">' +
                    '<span class="fa fa-save file-info-button-class"></span>' +
                  '</div>' +
                '</td>' +
                '<td class="ui-pg-button ui-corner-all" title="Mostrar observação">' +
                  '<div class="dz-remove expand-file-attribute" style="padding-right: 2px" id-file-info="IDFILE">' +
                    '<span class="fa fa-eye file-info-button-class"></span>' +
                  '</div>' +
                '</td>' +
              '</tr>' +
            '</tbody>' +
          '</table>' +
        '<div>';

    // Template attachment
    this._fileEditorTemplate =
        '<div id="file-row-IDFILE" class="row file-row-div">' +
          '<form id="file-form-IDFILE" role="form" method="post">' +
            '<div>' +
              '<div id="file-div-IDFILE" class="file-zone-div col-xs-12 col-sm-12 col-md-12 col-lg-12" style="text-align: center;">' + // The file
              '</div>' + 
              '<div class="file-info-zone-div col-xs-8 col-sm-8 col-md-8 col-lg-8" style="display:none;">' + // Information File
                //'<div class="row" style="margin-left: 5px;">' + // Name
                //  '<label class="input file-label-info name" title="Nome do ficheiro">' +
                //    '<input id="file-name-IDFILE" name="name_file_user" class="file-name-input" type="text" rows="1" readonly></input>' +
                //    '<input id="file-id-entity-IDFILE" name="id_entity" type="hidden"/>' +
                //  '</label>' +
                //'</div>' +
                '<div class="row" style="margin-left: 5px;">' + // Observations
                  '<label class="input file-label-info last" title="Observa&#231;&#227;o">' +
                    '<textarea id="file-observations-IDFILE" name="observations" class="file-observation-textarea" type="text" rows="3"></textarea>' +
                  '</label>' +
                '</div>' +
                '<div class="row">' + // Data & user
                  '<label class="input file-label-info info" title="Nome">' +
                      'Adicionado por <span id="file-user-IDFILE"></span> em <span id="file-date-IDFILE"></span>' +
                  '</label>' +
                  //// User
                  //'<div class="col-md-6" style="padding-left:0px;padding-right:0px">' +
                  //  '<label class="input file-label-info" title="Utilizador" style="width: 100%;margin-bottom:0px">' +
                  //    '<input id="file-user-IDFILE" name="user_name" readonly class="file-user-input" type="text" rows="1"></input>' +
                  //  '</label>' +
                  //'</div>' +
                  //// Date
                  //'<div class="col-md-6" style="padding-left:0px;padding-right: 0px;">' +
                  //  '<label class="input file-label-info" title="Data" style="width: 100%;margin-bottom:0px">' +
                  //    '<input id="file-date-IDFILE" name="dt_process" readonly class="file-date-input" type="text" rows="1"></input>' +
                  //  '</label>' +
                  //'</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</form>' +
        '</div>';

    this._fileEditorTemplateFileZoneDivWithExpand = "file-zone-div col-xs-4 col-sm-4 col-md-4 col-lg-4";
    this._fileEditorTemplateFileZoneDivNoExpand = "file-zone-div col-xs-12 col-sm-12 col-md-12 col-lg-12";

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Build Dropzone for water
     * @param {string} formNodeId, form upload dropzone identifier
     * @param {string} arrayButton, array of button id node identifier
     * @param {int} thumbWidth, thumbnail width
     * @param {int} thumbHeight, thumbnail height
     * @param {int} maxFiles, max file allowed
     * @param {int} maxFileSize, max file size
     * @param {string} codContext, context code
     * @param {string} codEntity, entity code
     */
    this.BuildDropzoneWater = function (formNodeId, arrayButton, thumbWidth, thumbHeight, maxFiles, maxFileSize, codContext, codEntity) {
        // Remove upload
        $('#id-offcanvas-body-layer-detail-attachment-zone').empty();
        // Destroy preview dropzone
        if (Dropzone.instances.length > 0) {
            myUpload.dropzoneUpload.destroy();
        }

        // Build upload form
        var formUpload = $('<form id="id-offcanvas-body-layer-detail-attachment-form" action="" class="" role="form" method="post" style="color: black;height:100%"/>');
        $('#id-offcanvas-body-layer-detail-attachment-zone').append(formUpload);

        // Init Dropzone
        myUpload.dropzoneUpload = new Dropzone('#' + formNodeId,
            {
                url: "/Data/UploadFile", //"?idUser=" + $('#sig-login-text')[0].getAttribute("id-user") + "&idEntity=" + idEntity + "&tableContext=" + tableContext + "&airport=" + airport,
                withCredentials: true,
                maxFiles: maxFiles,
                maxFilesize: maxFileSize,
                addRemoveLinks: true,
                thumbnailWidth: thumbWidth,
                thumbnailHeight: thumbHeight,
                parallelUploads: 40,
                dictCancelUpload: 'Cancelar anexo',
                //clickable: arrayButton,
                init: function () {
                    var _this = this;

                    // Get all file water reference
                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/FileManager/GetFileAttachmentWater?codContext=' + codContext + "&codEntity=" + codEntity,
                        async: true,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção dos ficheiros");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        if (data.result.list_file && data.result.list_file.length > 0) {
                                            for (var i = 0; i < data.result.list_file.length; i++) {
                                                var fileDetail = data.result.list_file[i];
                                                // Add file
                                                var mockFile = { name: fileDetail.file_name, size: fileDetail.file_size, idFile: fileDetail.file_id };
                                                _this.options.addedfile.call(_this, mockFile);

                                                // Create file structure
                                                _this.options.thumbnail.call(_this, mockFile, fileDetail.file_byte);
                                                $(mockFile.previewElement).find('.dz-image img').addClass('size-image');

                                                var lightBoxElement = $('<a href="' + fileDetail.file_byte + '" data-lightbox="' + codEntity + '" data-title="' + fileDetail.file_name + '"/>');
                                                $(mockFile.previewElement).find('.dz-image').append(lightBoxElement);
                                                $(mockFile.previewElement).find('.dz-image img').appendTo(lightBoxElement);
                                            }
                                            $('.dz-progress').hide();
                                            $('.dz-size').hide();
                                            $('.dz-error-mark').hide();
                                            $('.dz-success-mark').hide();
                                            $('.dz-filemane').hide();
                                            $('.dz-details').hide();
                                            $('.dz-remove').hide();
                                        }
                                        break;
                                    case 'NO_FILE':
                                        break;
                                    case 'ERROR':
                                        toastr["error"]("Erro na obtenção dos ficheiros");
                                        break;
                                    default:
                                }
                            }

                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção dos ficheiros");
                        }
                    });
                }
            });
    };

    /**
     * Upload attachment
     * @param {string} idEntity, id entity
     * @param {string} nameEntity, entity name
     * @param {string} idNodeUploadZone, id node upload zone
     * @param {string} idNodeFormUpload, id node form upload
     * @param {string} idNodeAddBtn, id node button add attachment
     * @param {string} classNumberFile, class for number of file
     * @param {string} idNodeShowWait, id node for spinner wait
     */
    this.LoadAttachment = function (idEntity, nameEntity, idNodeUploadZone, idNodeFormUpload, idNodeAddBtn, classNumberFile, idNodeShowWait) {
        var withAddFileUploadBtn = true;
        var arrayClickableDropzone = ["#" + idNodeAddBtn];

        // In the begin we dont know the number of file
        $('.' + classNumberFile + ' span')[0].innerHTML = "-";

        // Mobile compatibility
        var capture = null;
        if (myUpload._utility.mobilecheck()) {
            $('#' + idNodeAddBtn + " i")[0].className = "gpi gpi-snapshot";
            $('#' + idNodeAddBtn).attr('title', 'Tirar fotografia');
            capture = "camera";
        }
        else {
            $('#' + idNodeAddBtn + " i")[0].className = "fa fa-plus";
            $('#' + idNodeAddBtn).attr('title', 'Adicionar anexo');
        }

        // Set mode
        var autoProcessQueue = true;
        var mode = "ENTITY_CREATED";
        if (idEntity == myUpload.fakeIdEntity) {
            autoProcessQueue = false;
            mode = "ENTITY_CREATION";
        }

        // -- Reset drop zone --
        // Remove upload
        $('#' + idNodeUploadZone).empty();
        // Destroy preview dropzone
        if (Dropzone.instances.length > 0) {
            if (myUpload.dropzoneUpload)
                myUpload.dropzoneUpload.destroy();
        }

        // Build upload form
        var formUpload = $('<form id="' + idNodeFormUpload + '" action="" class="" role="form" method="post" style="color: black;height:100%"/>');
        $('#' + idNodeUploadZone).append(formUpload);

        // -- Dropzone Prototype submitRequest - Replace xmlHttpRequest upload to $ajax upload
        Dropzone.prototype.submitRequest = function (xhr, formData, files) {
            // Start wait
            myUpload._utility.ShowWait(idNodeShowWait, true);

            switch (mode) {
                case "ENTITY_CREATED":
                    $.ajax(
                    {
                        type: 'POST',
                        url: this.options.url,
                        cache: false,
                        contentType: false,
                        processData: false,
                        xhrFields: {
                            withCredentials: true
                        },
                        crossDomain: true,
                        data: formData,
                        statusCode: {
                            500: function () {
                                var _this = Dropzone.forElement('#' + idNodeFormUpload);
                                var filesArray = _this.files;

                                // Remove file from list
                                for (var i = 0; i < filesArray.length; i++) {
                                    $(filesArray[i].previewElement).removeClass('dz-processing');
                                    $(filesArray[i].previewElement).addClass('dz-error');
                                    filesArray[i].previewElement.querySelector("[data-dz-errormessage]").textContent = "Atenção, ficheiro não adicionado.";
                                }
                                // Error description
                                toastr["error"]("Erro na adição de um ficheiro");

                                // Stop wait
                                myUpload._utility.ShowWait(idNodeShowWait, false);
                            }
                        },
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na adição de um ficheiro");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        // Get the file array
                                        var _this = Dropzone.forElement('#' + idNodeFormUpload);
                                        var filesArray = files; //_this.files;

                                        for (var i = 0; i < filesArray.length; i++) {
                                            if (filesArray[i].name === data.result.data.name_file_user) {
                                                // Remove all mark
                                                $('.dz-progress').hide();
                                                $('.dz-size').hide();
                                                $('.dz-error-mark').hide();
                                                $('.dz-success-mark').hide();
                                                $('.dz-filemane').hide();
                                                $('.dz-details').hide();

                                                // Create file structure
                                                myUpload._AddFileInfoStructure(_this, filesArray[i], data.result.data, idEntity, false, true, myUpload._fileEditorTemplate, null, idNodeFormUpload, classNumberFile, idNodeShowWait, mode);

                                                // Set msg sucess
                                                toastr["success"]("Ficheiro adicionado com sucesso");
                                            }
                                        }

                                        // Number of file
                                        if ($('#' + idNodeFormUpload + ' .file-row-div').length == 0)
                                            $('.' + classNumberFile + ' span')[0].innerHTML = 0;
                                        else
                                            $('.' + classNumberFile + ' span')[0].innerHTML = $('#' + idNodeFormUpload + ' .file-row-div').length;

                                        break;
                                    default: // Error
                                        var _this = Dropzone.forElement('#' + idNodeFormUpload);
                                        var filesArray = _this.files;

                                        // Remove file from list
                                        for (var i = 0; i < filesArray.length; i++) {
                                            $(filesArray[i].previewElement).removeClass('dz-processing');
                                            $(filesArray[i].previewElement).addClass('dz-error');
                                            if (data.result.status == 'ERROR_TYPE')
                                                filesArray[i].previewElement.querySelector("[data-dz-errormessage]").textContent = "Atenção, ficheiro não adicionado. Tipo de ficheiro não suportado";
                                            else
                                                filesArray[i].previewElement.querySelector("[data-dz-errormessage]").textContent = "Atenção, ficheiro não adicionado.";
                                        }
                                        // Error description
                                        toastr["error"]("Erro na adição de um ficheiro");
                                }
                            }

                            // Stop wait
                            myUpload._utility.ShowWait(idNodeShowWait, false);
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            toastr["error"]("Erro na adição de um ficheiro");
                            // Stop wait
                            myUpload._utility.ShowWait(idNodeShowWait, false);
                        }
                    });
                    break;
                case "ENTITY_CREATION":
                    $.ajax(
                        {
                            type: 'POST',
                            url: "/rest/app/FileManager/UploadFile?idUser=" + myUpload._userId + "&idEntity=" + myUpload.newIdEntity + "&nameEntity=" + nameEntity,
                            cache: false,
                            contentType: false,
                            processData: false,
                            xhrFields: {
                                withCredentials: true
                            },
                            crossDomain: true,
                            data: formData,
                            success: function (data) {
                                if (data.error) {
                                    toastr["error"]("Erro na adição de um ficheiro");
                                }
                                else {
                                    switch (data.result.status) {
                                        case 'SUCCESS':
                                            break;
                                        default: // Error
                                    }
                                }

                                // Stop wait
                                myUpload._utility.ShowWait(idNodeShowWait, false);
                            },
                            error: function (xhr, ajaxOptions, thrownError) {
                                toastr["error"]("Erro na adição de um ficheiro");
                                // Stop wait
                                myUpload._utility.ShowWait(idNodeShowWait, false);
                            }
                        });
                    break;
                default:
                    // do nothing
            }
        };

        // -- Dropzone definition -- 
        myUpload.dropzoneUpload = new Dropzone('#' + idNodeFormUpload,
        {
            url: "/rest/app/FileManager/UploadFile?idUser=" + myUpload._userId + "&idEntity=" + idEntity + "&nameEntity=" + nameEntity,
            withCredentials: true,
            maxFiles: 120,
            maxFilesize: 90048,
            addRemoveLinks: true,
            thumbnailWidth: 160,
            thumbnailHeight: 160,
            parallelUploads: 40,
            dictCancelUpload: 'Cancelar anexo',
            clickable: arrayClickableDropzone,
            capture: capture,
            autoProcessQueue: autoProcessQueue,
            init: function () {
                var _this = this;

                switch (mode) {
                    case "ENTITY_CREATED":
                        // Start wait
                        myUpload._utility.ShowWait(idNodeShowWait, true);
                        
                        // Gets all entity files from Server
                        var paramFileEntity = $.param({ "idEntity": idEntity, "nameEntity": nameEntity });
                        $.ajax(
                        {
                            type: 'GET',
                            url: "/rest/app/FileManager/GetAllFileEntity?" + paramFileEntity,
                            async: true,
                            success: function (data) {
                                if (data.error) {
                                    toastr["error"]("Erro no carregamento dos anexos associados à entidade");
                                }
                                else {
                                    switch (data.result.status) {
                                        case "NO_AUTHORIZE":
                                            toastr["error"]("Sem autorização para listar anexos");
                                            break;
                                        case "NO_FILE":
                                            $('.' + classNumberFile + ' span')[0].innerHTML = 0;
                                            break;
                                        case "SUCCESS":
                                            if (data.result.files && data.result.files.length > 0) {
                                                for (var i = 0; i < data.result.files.length; i++) {
                                                    var fileDetail = data.result.files[i];
                                                    // Add file
                                                    var mockFile = { name: fileDetail.name_file_user, size: fileDetail.name_file_user, idFile: fileDetail.id_file_info };
                                                    _this.options.addedfile.call(_this, mockFile);

                                                    // Create file structure
                                                    myUpload._AddFileInfoStructure(_this, mockFile, fileDetail, idEntity, true, true, myUpload._fileEditorTemplate, null, idNodeFormUpload, classNumberFile, idNodeShowWait, mode);
                                                }

                                                // Number of file
                                                if ($('#' + idNodeFormUpload + ' .file-row-div').length == 0)
                                                    $('.' + classNumberFile + ' span')[0].innerHTML = 0;
                                                else
                                                    $('.' + classNumberFile + ' span')[0].innerHTML = $('#' + idNodeFormUpload + ' .file-row-div').length;

                                                // Remove class
                                                $('.dz-progress').hide();
                                                $('.dz-size').hide();
                                                $('.dz-error-mark').hide();
                                                $('.dz-success-mark').hide();
                                                $('.dz-filemane').hide();
                                                $('.dz-details').hide();
                                            }
                                            break;
                                        default:
                                            toastr["error"]("Erro no carregamento dos anexos associados à entidade");
                                    }
                                }

                                // Stop wait
                                myUpload._utility.ShowWait(idNodeShowWait, false);
                            },
                            error: function (request, status, error) {
                                toastr["error"]("Erro no carregamento dos anexos associados à entidade");
                                // Stop wait
                                myUpload._utility.ShowWait(idNodeShowWait, false);
                            }
                        });
                        break;
                    case "ENTITY_CREATION":
                        _this.on("addedfile", function (file) {
                            // Start wait
                            myUpload._utility.ShowWait(idNodeShowWait, true);

                            var fileName = file.upload.filename;

                            $.ajax(
                            {
                                type: 'GET',
                                url: "/rest/app/FileManager/GetBuildFileInfoByFileName?idUser=" + myUpload._userId + "&idEntity=" + idEntity + "&nameEntity=" + nameEntity + "&fileName=" + fileName,
                                async: true,
                                success: function (data) {
                                    if (data.error) {
                                        toastr["error"]("Erro na adição de um ficheiro");
                                    }
                                    else {
                                        switch (data.result.status) {
                                            case 'SUCCESS':
                                                // Remove all mark
                                                $('.dz-progress').hide();
                                                $('.dz-size').hide();
                                                $('.dz-error-mark').hide();
                                                $('.dz-success-mark').hide();
                                                $('.dz-filemane').hide();
                                                $('.dz-details').hide();

                                                // Create file structure
                                                myUpload._AddFileInfoStructure(_this, file, data.result.data, idEntity, false, true, myUpload._fileEditorTemplate, null, idNodeFormUpload, classNumberFile, idNodeShowWait, mode);

                                                // Number of file
                                                if ($('#' + idNodeFormUpload + ' .file-row-div').length == 0)
                                                    $('.' + classNumberFile + ' span')[0].innerHTML = 0;
                                                else
                                                    $('.' + classNumberFile + ' span')[0].innerHTML = $('#' + idNodeFormUpload + ' .file-row-div').length;

                                                // Set msg sucess
                                                toastr["success"]("Ficheiro adicionado com sucesso");
                                                break;
                                            default: // Error
                                                var filesArray = _this.files;

                                                // Remove file from list
                                                for (var i = 0; i < filesArray.length; i++) {
                                                    $(filesArray[i].previewElement).removeClass('dz-processing');
                                                    $(filesArray[i].previewElement).addClass('dz-error');
                                                    if (data.result.status == 'ERROR_TYPE')
                                                        filesArray[i].previewElement.querySelector("[data-dz-errormessage]").textContent = "Atenção, ficheiro não adicionado. Tipo de ficheiro não suportado";
                                                    else
                                                        filesArray[i].previewElement.querySelector("[data-dz-errormessage]").textContent = "Atenção, ficheiro não adicionado.";
                                                }
                                                // Error description
                                                toastr["error"]("Erro na adição de um ficheiro");
                                        }
                                    }

                                    // Stop wait
                                    myUpload._utility.ShowWait(idNodeShowWait, false);
                                },
                                error: function (xhr, ajaxOptions, thrownError) {
                                    toastr["error"]("Erro na adição de um ficheiro");
                                    // Stop wait
                                    myUpload._utility.ShowWait(idNodeShowWait, false);
                                }
                            });
                        });
                        break;
                    default:
                        // do Nothing
                }
            }
        });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Create the structure of a file in the upload area
     * @param {object} _this dropzone object
     * @param {object} file file object
     * @param {object} fileDetail file detail object
     * @param {string} idEntity identifier of the entity
     * @param {bool} createThumbnail indication if we are creating de thumbnail with information of the server (true) or adding a file to the thumbnail (false)
     * @param {bool} addFile, indicate add file action
     * @param {string} template, template for alfanuméric append information
     * @param {string} buttonsTemplate, template for buttons operation
     * @param {string} idNodeFormUpload, id form
     * @param {string} idNodeShowWait, id node for spinner wait
     * @param {string} classNumberFile, class for number of file
     * @param {string} mode, mode entity
     */
    this._AddFileInfoStructure = function (_this, file, fileDetail, idEntity, createThumbnail, addFile, template, buttonsTemplate, idNodeFormUpload, classNumberFile, idNodeShowWait, mode) {
        // Move previewElement to div row
        var editorUploadForm = $(_this.element);
        var templateInUse = myUpload._fileEditorTemplate;
        if (template) {
            templateInUse = template;
        }
        var divRow = $(templateInUse.replace(/IDFILE/g, fileDetail.id_file_info));
        $(editorUploadForm).prepend(divRow);
        $(file.previewElement).appendTo($('#file-div-' + fileDetail.id_file_info));

        // Check visibility
        if (addFile) {
            divRow.removeClass('ol-hidden');
        }
        else
            divRow.addClass('ol-hidden');

        // Build file Thumbnail
        var source = fileDetail.src_base64;
        var classImage = 'size-image';

        if (!fileDetail.image) {
            source = window.location.origin + "/images/" + fileDetail.extension + "-icon.png";
            classImage = 'size-image-icon';
        }

        if (createThumbnail) // Just when we add file in init
        {
            _this.options.thumbnail.call(_this, file, source);
        }
        else {
            if (!fileDetail.image)
                $(file.previewElement).find('.dz-image img').attr('src', source);
            $(file.previewElement).removeClass('dz-file-preview');
            $(file.previewElement).addClass('dz-image-preview'); // dz-image-preview nicer to view
        }
        $(file.previewElement).find('.dz-image img').addClass(classImage);

        // Add file preview lightbox
        if (fileDetail.image) {
            var lightBoxElement = $('<a href="' + source + '" data-lightbox="' + idEntity + '" data-title="' + fileDetail.name_file_user + '"/>');
            $(file.previewElement).find('.dz-image').append(lightBoxElement);
            $(file.previewElement).find('.dz-image img').appendTo(lightBoxElement);
        }

        // Remove button remove
        $(file.previewElement).find('.dz-remove').remove();

        // Add new buttons operation on the file
        var buttonsTemplateInUse = myUpload._buttonsTemplate;
        if (buttonsTemplate) {
            buttonsTemplateInUse = buttonsTemplate;
        }
        var buttonsElement = $(buttonsTemplateInUse.replace(/IDFILE/g, fileDetail.id_file_info).replace(/EXTENSION_FILE/g, fileDetail.extension).replace(/NAME_FILE/g, fileDetail.name_file_user).replace(/NAME_ENTITY/g, fileDetail.name_entity).replace(/ID_ENTITY/g, fileDetail.id_entity).replace(/S_File/g, source));
        $(file.previewElement).append(buttonsElement);

        // Add event listener to the new remove file button
        var removeButton = $(file.previewElement).find('.delete-file');
        removeButton[0].addEventListener("click", function (e) {
            var x = confirm('Deseja remover o ficheiro ' + fileDetail.name_file_user + '?');
            if (!x) return false;

            // Start wait
            myUpload._utility.ShowWait(idNodeShowWait, true);

            switch (mode) {
                case "ENTITY_CREATION":
                    // Remove all row file element
                    e.preventDefault();
                    e.stopPropagation();
                    _this.removeFile(file);
                    $('#file-row-' + fileDetail.id_file_info).remove();
                    // Count number of file
                    if ($('#' + idNodeFormUpload + ' .file-row-div').length == 0)
                        $('.' + classNumberFile + ' span')[0].innerHTML = 0;
                    else
                        $('.' + classNumberFile + ' span')[0].innerHTML = $('#' + idNodeFormUpload + ' .file-row-div').length;
                    toastr["success"]("Remoção efectuada com sucesso");
                    break;
                default:
                    var params = $.param({ "idEntity": idEntity, "nameEntity": fileDetail.name_entity, "idFileInfo": fileDetail.id_file_info });
                    $.ajax(
                    {
                        type: 'DELETE',
                        url: "/rest/app/FileManager/DeleteFile?" + params,
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na remoção do ficheiro");
                            }
                            else {
                                switch (data.result.status) {
                                    case 'SUCCESS':
                                        // Remove all row file element
                                        e.preventDefault();
                                        e.stopPropagation();
                                        _this.removeFile(file);
                                        $('#file-row-' + fileDetail.id_file_info).remove();
                                        // Count number of file
                                        if ($('#' + idNodeFormUpload + ' .file-row-div').length == 0)
                                            $('.' + classNumberFile + ' span')[0].innerHTML = 0;
                                        else
                                            $('.' + classNumberFile + ' span')[0].innerHTML = $('#' + idNodeFormUpload + ' .file-row-div').length;
                                        toastr["success"]("Remoção efectuada com sucesso");
                                        break;
                                    case 'NO_AUTHORIZE':
                                        toastr["error"]("Sem autorização para remover o ficheiro");
                                        break;
                                    default: // Error
                                        toastr["error"]("Erro na remoção do ficheiro");
                                }
                            }
                            // Stop wait
                            myUpload._utility.ShowWait(idNodeShowWait, false);
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            toastr["error"]("Erro na remoção do ficheiro");
                            // Stop wait
                            myUpload._utility.ShowWait(idNodeShowWait, false);
                        }
                    });
            }
        });

        // Remove download button if mobile
        if (myUpload._utility.mobilecheck()) {
            $(file.previewElement).find('.download-file').parent().toggle('ol-hidden');
        }
        else {
            // Add event listener to download file button
            var downloadButton = $(file.previewElement).find('.download-file');
            downloadButton[0].addEventListener("click", function (e) {
                myUpload._DownloadFile(this);
            });
        }

        // Save attribute
        if (mode !== "ENTITY_CREATION") {
            var saveAttributeButton = $(file.previewElement).find('.save-file-attribute');
            saveAttributeButton[0].addEventListener("click", function (e) {
                var observations = $('#file-observations-' + fileDetail.id_file_info).val();
                var params = $.param({ "idFileInfo": fileDetail.id_file_info, "observations": observations });

                // Start wait
                myUpload._utility.ShowWait(idNodeShowWait, true);

                $.ajax(
                {
                    type: 'POST',
                    url: "/rest/app/FileManager/SaveFileInformation?" + params,
                    contentType: "application/json",
                    async: true,
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na gravação da observação");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    toastr["success"]("Gravação da observação efectuada com sucesso");
                                    break;
                                default: // Error
                                    toastr["error"]("Erro na gravação da observação");
                            }
                        }
                        // Stop wait
                        myUpload._utility.ShowWait(idNodeShowWait, false);
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        toastr["error"]("Erro na gravação da observação");
                        // Stop wait
                        myUpload._utility.ShowWait(idNodeShowWait, false);
                    }
                });
            });
        }

        // Expand
        if (mode == "ENTITY_CREATION") {
            $(file.previewElement).find('.expand-file-attribute').toggle('ol-hidden');
        }

        // Add evento listener to expand button
        var expandButton = $(file.previewElement).find('.expand-file-attribute');
        expandButton[0].addEventListener("click", function (e) {
            var idFileInfo = this.getAttribute('id-file-info');

            if (!$(this).hasClass("expand")) { // Expand
                $(this).addClass("expand");
                $('#file-row-' + idFileInfo).addClass('expand');
                $('#file-row-' + idFileInfo).find('.file-info-button').addClass("expand");
                $('#file-row-' + idFileInfo).find('.dz-image').addClass("expand");
                $('#file-div-' + idFileInfo)[0].className = myUpload._fileEditorTemplateFileZoneDivWithExpand;
            }
            else { // Remove expand
                $(this).removeClass("expand");
                $('#file-row-' + idFileInfo).removeClass('expand');
                $('#file-row-' + idFileInfo).find('.file-info-button').removeClass("expand");
                $('#file-row-' + idFileInfo).find('.dz-image').removeClass("expand");
                $('#file-div-' + idFileInfo)[0].className = myUpload._fileEditorTemplateFileZoneDivNoExpand;
            }

            // Show atribute
            $('#file-row-' + idFileInfo).find('.file-info-zone-div').toggle('ol-hidden');

            // Show save attribute button
            if (mode !== "ENTITY_CREATION")
                $('#file-row-' + idFileInfo).find('.save-file-attribute').parent().toggle('ol-hidden');

            // Change expand icon
            $(this).find('span').toggleClass("fa-eye fa-eye-slash");
        });

        // Fill data element
        for (var key in fileDetail) {
            switch (key) {
                case "dt_process":
                    $('#file-date-' + fileDetail.id_file_info)[0].innerHTML = myUpload._utility.TransformDateServerInDateII(fileDetail[key].substr(0, 10));
                    break;
                case "user_name":
                    $('#file-user-' + fileDetail.id_file_info)[0].innerHTML = fileDetail[key];
                    break;
                case "name_file_user":
                    $("#file-div-" + fileDetail.id_file_info).find('img').attr('title', fileDetail[key]);
                    break;
                default:
                    if ($("#file-form-" + fileDetail.id_file_info + " [name='" + key + "']").length > 0 && fileDetail[key] && fileDetail[key] !== "")
                        $("#file-form-" + fileDetail.id_file_info + " [name='" + key + "']")[0].value = fileDetail[key];
            }
        }
    }

    /**
     * Upload
     * Download file
     * @param {element} element element of the button
     */
    this._DownloadFile = function(element) {
        var idFileInfo = element.getAttribute('href');
        var nameFile = element.getAttribute('name-file-user');
 
        //var params = $.param({ "idFileInfo": idFileInfo });
        var a = $("<a>").attr("href", idFileInfo).attr("download", nameFile).appendTo("body");
        a[0].click();
        a.remove();
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    // -- end event -------------------------------------------------------------------------------
};